import { render, staticRenderFns } from "./DetailReturnResult.vue?vue&type=template&id=1ca2cfb8&scoped=true"
import script from "./DetailReturnResult.vue?vue&type=script&lang=js"
export * from "./DetailReturnResult.vue?vue&type=script&lang=js"
import style0 from "./DetailReturnResult.vue?vue&type=style&index=0&id=1ca2cfb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca2cfb8",
  null
  
)

export default component.exports